import React from "react";

function Button({ children, onClick, variant, className, type }) {
  const getVariant = () => {
    if (variant === "secondary") {
      return "btn btn-secondary";
    }
    if (variant === "hero") {
      return "btn-hero";
    }

    return "btn btn-primary";
  };

  return (
    <button
      type={type}
      onClick={onClick}
      className={`${getVariant()} ${className}`}
    >
      {children}
    </button>
  );
}

export default Button;
